<template>
  <div>
    <h1>Nova de tipo_instrumento</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("tipos_instrumentos", ["tipo_instrumento"]),
  },
  methods: {
    ...mapActions("tipos_instrumentos", ["ActionNewtipo_instrumento"]),
    loadData(id) {
      this.$router.push({
        name: "tipos_instrumentos_edit",
        params: { id: id },
      });
    },
  },
  async created() {
    this.ActionNewtipo_instrumento();
  },
};
</script>

<style></style>
